export default [
  {
    path: "license",
    component: () =>
      import(
        "@/pages/EntityManagementPages/LicenseManagementPages/LicenseListPage"
      ),
  },
  {
    path: "license/new",
    component: () =>
      import(
        "@/pages/EntityManagementPages/LicenseManagementPages/LicenseCreatePage"
      ),
  },
  {
    path: "license/:licenseId",
    component: () =>
      import(
        "@/pages/EntityManagementPages/LicenseManagementPages/LicenseDetailsPage"
      ),
    props: (route) => ({ licenseId: route.params.licenseId }),
  },
];
